import { useId } from 'react';

import classNames from 'classnames';

import Flex from '../../../Layout/components/Flex';

import { CheckboxFilledIcon, CheckboxIcon, CheckboxPartialIcon } from '../../../../icons';

import styles from './_index.module.scss';

export interface CheckboxProps {
  className?: string;
  'data-testid'?: string;
  helpText?: string;
  id?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  isIndeterminate?: boolean;
  label: React.ReactNode;
  onChange: (value: any) => void;
  title?: string;
  value: any;
}

const Checkbox = ({
  className,
  helpText,
  id,
  isChecked,
  isDisabled,
  isIndeterminate,
  label,
  onChange,
  title,
  value,
  ...props
}: CheckboxProps) => {
  const generatedId = useId();
  const inputId = id ? `${id}-input` : generatedId;
  const handleChange = () => {
    if (!isDisabled) {
      onChange(value);
    }
  };

  const renderIcon = () => {
    if (isChecked) return <CheckboxFilledIcon />;
    if (isIndeterminate) return <CheckboxPartialIcon />;
    return <CheckboxIcon />;
  };

  return (
    <div
      className={classNames(styles['checkbox'], className, {
        [styles['is-active']]: isChecked || isIndeterminate,
        [styles['is-disabled']]: isDisabled,
      })}
      id={id}
      {...props}
    >
      <input disabled={isDisabled} id={inputId} onChange={handleChange} type="checkbox" />
      <Flex as="label" gap="small" htmlFor={inputId}>
        <div className={styles['checkbox-icon']}>{renderIcon()}</div>
        <div className={styles['checkbox-text']}>
          <div className={styles['checkbox-label-text']} title={title}>
            {label}
          </div>
          {helpText && <div className={styles['checkbox-help-text']}>{helpText}</div>}
        </div>
      </Flex>
    </div>
  );
};

export default Checkbox;
